
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants",
      function () {
        return require("private-next-pages/variants/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants"])
      });
    }
  